module.exports = __webpack_public_path__ + "entry-150bfe9b/julia-reichhofer-photo-9d4a1c464189f43565c4d66a0c0d85d2.webp";